import { Field, Float, ID, InputType, ObjectType } from 'type-graphql'
import { BaseEntity } from '../base/BaseEntity'
import { modelOptions, Prop, PropType } from '@typegoose/typegoose'
import { Address } from '../address/Address'
import { Customer } from '../customer/Customer'
import { LogisticItem } from './LogisticItem'
import type { LogisticStatusEnum } from './LogisticStatusEnum'
import { Order } from '../order/Order'
import { RelatedEntity } from '../base/RelatedEntity'
import { Activity } from '../activity/Activity'
import { DocumentLock } from '../documentLock/DocumentLock'
import { WorkOrder } from '../work-order/WorkOrder'
import { generateEntityId } from '../generateEntityId'

@ObjectType()
@InputType('LogisticInput')
@modelOptions({ schemaOptions: { timestamps: true } })
export class Logistic extends BaseEntity {
  @Field(() => ID)
  @Prop({ type: String, required: true, default: () => generateEntityId('lo') })
  declare _id: string

  @Field(() => Date)
  @Prop({ type: Date })
  shipDate: Date

  @Field(() => String)
  @Prop({ type: String })
  shipVia: string

  @Field(() => Customer)
  @Prop({ type: Customer })
  vendor: Customer

  @Field(() => Address)
  @Prop({ type: Address })
  vendorAddress: Address

  @Field(() => Customer)
  @Prop({ type: Customer })
  shipTo: Customer

  @Field(() => Address)
  @Prop({ type: Address })
  shipToAddress: Address

  @Field(() => [LogisticItem])
  @Prop({ type: () => [LogisticItem] })
  items: LogisticItem[]

  @Field(() => Float)
  @Prop({ type: Number })
  totalQuantity: number

  @Field(() => String)
  @Prop({ type: String })
  declare status: LogisticStatusEnum

  @Field(() => [String])
  @Prop({ type: [String] })
  instructions: string[]

  @Field(() => Date)
  @Prop({ type: Date })
  expectedFinishDate: Date

  @Field(() => [Order])
  @Prop({ type: [String] })
  relatedSalesOrders: Order[]

  /**
   * These are the _id of orders that are related to this logistic
   */
  @Field(() => [Logistic])
  @Prop({ type: [RelatedEntity] }, PropType.ARRAY)
  relatedLogistics: ReturnType<() => Logistic[]>

  @Field(() => [WorkOrder])
  @Prop({ type: [RelatedEntity] }, PropType.ARRAY)
  relatedWorkOrders: ReturnType<() => WorkOrder[]>

  @Field(() => [Activity])
  @Prop({ type: [Activity] })
  remarksActivity: Activity[]

  //This has field resolver, but we put it here for type-safety too
  @Field(() => DocumentLock)
  documentLock: DocumentLock
}
